import { Input } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'

interface LayoutLinkProps {}

const LayoutLink: FC<LayoutLinkProps> = () => {
    const name = 'layoutLink'

    return (
        <Form.Item name={name} label={'Ссылка на макет'}>
            <Input />
        </Form.Item>
    )
}

export default LayoutLink
